import { AlightCustomSettingsType } from '../../settings/alight-custom-settings';
import InitializationDataRequestProcessor from './request-processor-initialization-data';

export default class InitializationData {
    _settings: AlightCustomSettingsType;
    _reqProc: InitializationDataRequestProcessor;

    constructor(settings: AlightCustomSettingsType) {
        this._settings = settings;
        this._reqProc = new InitializationDataRequestProcessor(settings);
    }

    getRequestProcessor() {
        return this._reqProc;
    }
}



// WEBPACK FOOTER //
// ./modules/request-processor-initialization-data/initializationData.ts